/**
 * @generated SignedSource<<21cfd639018c25f0b3f294b05cb4a171>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrderFailReason = "CANCELLED_BY_USER" | "CANCELLED_DUE_TO_ASSET_DISABLING" | "EXPIRED" | "ORDER_EXECUTION_ERROR" | "SLIPPAGE_EVALUATION" | "USER_ACCOUNT_INACTIVE" | "USER_TRANSACTION_INACTIVE_CRYPTOCOIN" | "USER_TRANSACTION_OPERATIONS_DISABLED" | "USER_TRANSACTION_TRADING_DISABLED";
export type OrderOperation = "BUY" | "SELL";
export type OrderStatus = "ACCEPTED" | "CANCELED" | "CREATED" | "EXPIRED" | "FAILED" | "FINISHED";
export type OrderByIdViewQuery$variables = {
  id: string;
};
export type OrderByIdViewQuery$data = {
  readonly order: {
    readonly __typename: "Order";
    readonly asset: {
      readonly __typename: string;
      readonly id: string;
      readonly logoUrl: string | null | undefined;
      readonly name: string | null | undefined;
      readonly price: PrecisionFloat | null | undefined;
      readonly priceBuy: PrecisionFloat | null | undefined;
      readonly priceSell: PrecisionFloat | null | undefined;
      readonly symbol: string | null | undefined;
    } | null | undefined;
    readonly assetAmount: PrecisionFloat | null | undefined;
    readonly createdAt: TimeScalar | null | undefined;
    readonly expiresAt: TimeScalar | null | undefined;
    readonly failReason: OrderFailReason | null | undefined;
    readonly fee: PrecisionFloat | null | undefined;
    readonly fiatAmount: PrecisionFloat | null | undefined;
    readonly id: string;
    readonly operation: OrderOperation;
    readonly slippagePercentage: number | null | undefined;
    readonly status: OrderStatus;
    readonly targetPrice: PrecisionFloat;
    readonly transaction: {
      readonly id: string;
    } | null | undefined;
    readonly updatedAt: TimeScalar | null | undefined;
  } | null | undefined;
};
export type OrderByIdViewQuery = {
  response: OrderByIdViewQuery$data;
  variables: OrderByIdViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "operation",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetPrice",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiatAmount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetAmount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "symbol",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceBuy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceSell",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fee",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slippagePercentage",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expiresAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "failReason",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrderByIdViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "order",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "transaction",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrderByIdViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "order",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "transaction",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "40b013809d99ef9f7702fd770b6dc0c3",
    "id": null,
    "metadata": {},
    "name": "OrderByIdViewQuery",
    "operationKind": "query",
    "text": "query OrderByIdViewQuery(\n  $id: ID!\n) {\n  order(id: $id) {\n    __typename\n    id\n    operation\n    status\n    targetPrice\n    fiatAmount\n    assetAmount\n    asset {\n      __typename\n      id\n      name\n      symbol\n      logoUrl\n      price\n      priceBuy\n      priceSell\n    }\n    fee\n    slippagePercentage\n    createdAt\n    updatedAt\n    expiresAt\n    transaction {\n      __typename\n      id\n    }\n    failReason\n  }\n}\n"
  }
};
})();

(node as any).hash = "8ba60cf119965b39549fce8a1def0c7f";

export default node;
